import type { LinkProps } from 'next/link';
import type { FC, SVGProps } from 'react';

import * as S from './DownloadableDocument.styles';

interface DownloadableDocumentProps extends LinkProps {
  Svg: FC<SVGProps<SVGSVGElement>>;
  text: string;
}
export const DownloadableDocument = ({
  Svg,
  href,
  text,
}: DownloadableDocumentProps) => {
  return (
    <S.Wrapper
      $isDisabled={!href}
      data-test-id='DownloadableDocumentWrapper'
      href={href}
    >
      <Svg data-test-id='DownloadableDocumentSvg' width={64} />
      <S.Text data-test-id='DownloadableDocumentText'>{text}</S.Text>
    </S.Wrapper>
  );
};

DownloadableDocument.displayName = 'DownloadableDocument';
